import { spaceCadet } from '@cogneed/react-utils';
import { FormControl, alpha, styled } from '@mui/material';

const StyledFormControl = styled(FormControl)({
  display: 'flex',
  gap: 8,
  flexDirection: 'row',
  flexWrap: 'nowrap',
  alignItems: 'flex-end',
  backgroundColor: 'white',
  borderTop: `1px solid ${alpha(spaceCadet[300], 0.5)}`,
  padding: '8px 8px',

  '& .MuiTextField-root': {
    flexGrow: 1,
    marginTop: 8,
  },
  '& .MuiTypography-h4': {
    fontSize: 12,
    lineHeight: '16px',
  },
  '& .price-update': {
    flexShrink: 0,
  },
  '& .MuiFormControl-root': {
    marginTop: 0,
    '& .MuiFormLabel-root': {
      top: -4,
      '&.MuiInputLabel-shrink': {
        top: 'unset',
        backgroundColor: 'transparent',
        color: spaceCadet[400],
      },
    },
  },
});

export default StyledFormControl;
